var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"d-print-none",attrs:{"depressed":""},on:{"click":_vm.onPrint}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v("mdi-printer")]),_vm._v("Seite drucken")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }